// @ts-nocheck
import {
  FETCH_PRODUCTS_FULFILLED,
  FETCH_PRODUCTS_REJECTED,
  FETCH_PRODUCT_FULFILLED,
  FETCH_PRODUCT_REJECTED,
  FETCH_PRODUCT_CHANGE_FULFILLED,
  FETCH_PRODUCT_CHANGE_REJECTED,
  FETCH_PRODUCT_CHANGE_NEXT_FULFILLED,
  FETCH_PRODUCT_CHANGE_NEXT_REJECTED,
  DELETE_PRODUCT_CHANGE_FULFILLED,
  SELECT_PRODUCT,
  DESELECT_PRODUCT,
} from './productActionTypes';

const initialState = {
  products: null,
  productDetails: null,
  productChanges: null,
};

export default function productReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PRODUCTS_FULFILLED:
      return {
        ...state,
        products: action.payload,
      };
    case FETCH_PRODUCTS_REJECTED:
      return {
        ...state,
        products: null,
      };
    case FETCH_PRODUCT_FULFILLED:
      return {
        ...state,
        productDetails: action.payload,
      };
    case FETCH_PRODUCT_REJECTED:
      return {
        ...state,
        productDetails: null,
      };
    case SELECT_PRODUCT:
      return {
        ...state,
        productDetails: state.products?.products?.find(x => x.id === action.payload),
      };
    case DESELECT_PRODUCT:
      return {
        ...state,
        productDetails: null,
      };
    case FETCH_PRODUCT_CHANGE_FULFILLED:
      return {
        ...state,
        productChanges: action.payload,
      };
    case FETCH_PRODUCT_CHANGE_REJECTED:
      return {
        ...state,
        productChanges: null,
      };
    case FETCH_PRODUCT_CHANGE_NEXT_FULFILLED:
      return {
        ...state,
        productChangesNext: action.payload.productChanges,
      };
    case FETCH_PRODUCT_CHANGE_NEXT_REJECTED:
      return {
        ...state,
        productChangesNext: null,
      };
    case DELETE_PRODUCT_CHANGE_FULFILLED:
      return {
        ...state,
        productChanges: action.payload,
      };
    default:
      return state;
  }
}
